import * as defaults from "./defaults";
import * as aws from "../aws-exports";
import { fetchRemoteValue } from "../configs/firebase_config";
import { Auth } from "aws-amplify";
import { event } from "react-ga";

// ==============================
// ========= ENVIROMENT =========
// ==============================

export const GET_PROD_OR_DEV = aws.RUNNING_ENVIROMENT;

// Log para ambiente de desenvolvimento
if (GET_PROD_OR_DEV === defaults.DEV) {
  console.log("###############################");
  console.log("######  DEVELOPMENT MODE ######");
  console.log("###############################");
}

// ==============================
// ======= CONFIG FROM FIREBASE =======
// ==============================
let API_URL = "";

// Variável que conterá o app_config carregado do Firebase
let appConfig = {
  API_URL_DEV: "https://sandbox.afinando.com.br",
  API_URL_PROD: "https://api.afinando.com.br",
};
async function initializeApp() {
  try {
    await loadAppConfig(); // Carrega o appConfig do Firebase
    console.log("Configuração carregada com sucesso:", appConfig);

    // Atualiza o API_URL após carregar o appConfig
    API_URL = getApiUrl(GET_PROD_OR_DEV);
    console.log("API_URL atualizado para:", API_URL);
  } catch (error) {
    console.error("Erro durante a inicialização do app:", error);
  }
}

// Função assíncrona para carregar a configuração do Firebase
async function loadAppConfig() {
  try {
    const configValue = await fetchRemoteValue("appConfig"); // Recupera o JSON do Firebase
    appConfig = JSON.parse(configValue); // Parse do JSON retornado
    console.log("Configuração carregada do Firebase:", appConfig);
  } catch (error) {
    console.error("Erro ao carregar configuração do Firebase:", error);
  }
}

// ==============================
// ========= BASE APIs ==========
// ==============================

// Função para acessar URLs com base na configuração
function getApiUrl(env) {
  return env === defaults.DEV ? appConfig.API_URL_DEV : appConfig.API_URL_PROD;
}

// Carregar a configuração ao inicializar
await initializeApp();

export const getUpdatedApiUrl = () => API_URL;

// ================================
// ===== APIs GOOGLE ANALITCS =====
// ================================

// RECAPTHCA V2
const SECRET_reCAPTCHA_DEV = "6Lfkwb8pAAAAAKDAgWYAEwpVsjMmZCZwgxtK7dhW";
const SECRET_reCAPTCHA_PROD = "6Ld_yL8pAAAAALbfn_pdrgQrlM1cxDtZ34XE8kCt";

export const SECRET_reCAPTCHA =
  GET_PROD_OR_DEV === defaults.DEV
    ? SECRET_reCAPTCHA_DEV
    : SECRET_reCAPTCHA_PROD;

//  Analytics salvos nos emails atendimento@...
const MAP_GOOGLE_ANALYTICS = {
  // [defaults.PROD]: "UA-163644675-3",
  // [defaults.DEV]: "UA-163644675-4",
  [defaults.PROD]: "G-MVK85JQDME",
  [defaults.DEV]: "G-H9059980BL",
};
export const GOOGLE_ANALYTICS = MAP_GOOGLE_ANALYTICS[GET_PROD_OR_DEV];

// Pixel - Facebook
const MAP_PIXEL_ID = {
  [defaults.PROD]: "1033654857083937", // Pixel salvo no emails atendimento@...
  [defaults.DEV]: "1035549276918007", // Pixel salvo no emails tota.braz@...
};
export const PIXEL_ID = MAP_PIXEL_ID[GET_PROD_OR_DEV];
export const API_PIXEL =
  "https://graph.facebook.com/v11.0/1033654857083937/events?access_token=EAAFb7lLWGtIBALaBSAqXKC6FVYmShWNBPYyhwZAqQlDpZCmwZA2ykABLJfmPi6OwnNHDhyzK2DP01iUQnDY7kzpxFJY3XXtZBFZChlhyxneDXUHMqvZCsDUOuc1ihqhKqYr8GPMsNqr5nz67TEtS5sZAhKWGVNIOVGbDsTGvXxT0ZCCxZCtCy0LMY";
export const API_RD_STATION =
  "https://api.rd.services/platform/conversions?api_key=4ce4d47361e9280cd64b560e3578ec97";

// Hotjar salvos nos emails atendimento@...
const MAP_HOTJAR_ID = {
  [defaults.PROD]: "2049443",
  [defaults.DEV]: null,
};
export const HOTJAR_ID = MAP_HOTJAR_ID[GET_PROD_OR_DEV];

// Hubspot salvos nos emails atendimento@...
const MAP_HUBSPOT_ID = {
  [defaults.PROD]: "6864341",
  [defaults.DEV]: null,
};
export const HUBSPOT_ID = MAP_HUBSPOT_ID[GET_PROD_OR_DEV];

// Amplifique.me
const MAP_AMPLIFIQUE_ME_ID = {
  [defaults.PROD]: "6006ee801dae85000e1a02ed",
  [defaults.DEV]: "600ad45da17f67000ebf6ac7",
};
export const AMPLIFIQUE_ME_ID = MAP_AMPLIFIQUE_ME_ID[GET_PROD_OR_DEV];

// ==============================
// ========= BASE APIs ==========
// ==============================

// const API_GAME_DEV = "https://d3icfn0mjhrrr3.cloudfront.net"; //CLOUDFRONT
//const API_GAME_DEV = "https://nextdev.afinandoocerebro.com.br/content/jogos";
const API_GAME_DEV = "https://dev.neuron.afinandoocerebro.com.br";
// const API_GAME_DEV = "http://afinando-jogos-export";
// const API_GAME_DEV = "http://localhost:8080/";
const API_GAME_PROD = "https://neuron.afinandoocerebro.com.br";
const isDev = GET_PROD_OR_DEV === defaults.DEV;
export const API_GAME =
  GET_PROD_OR_DEV === defaults.DEV ? API_GAME_DEV : API_GAME_PROD;

export const LINK_HOW_TO_USE_INVITE_CODE =
  "https://www.youtube.com/watch?v=ns5laCmuL6E";
export const LINK_HOW_TO_USE_INVITE_LINK = "https://youtu.be/W7l5UhFvtuQ";
const API_URL_DEV =
  "https://k9357p16ih.execute-api.us-east-1.amazonaws.com/next-dev-2";
const API_URL_PROD =
  "https://mcqj5lejdg.execute-api.us-east-1.amazonaws.com/v1";

const STATIC_API_DEV = "https://nextdev.afinandoocerebro.com.br";
export const STATIC_API_PROD = "https://novo.afinandoocerebro.com.br";

const PROBRAIN_LINK_DEV = "https://probraindev.afinandoocerebro.com.br";
const PROBRAIN_LINK_PROD = "https://probrain.afinandoocerebro.com.br";
export const PROBRAIN_LINK =
  GET_PROD_OR_DEV === defaults.DEV ? PROBRAIN_LINK_DEV : PROBRAIN_LINK_PROD;

const AFINANDO_PLUS_LINK_DEV = "https://hafinandoplus.probrain.com.br/";
const AFINANDO_PLUS_LINK_PROD = "https://afinandoplus.probrain.com.br/";
export const AFINANDO_PLUS_LINK =
  GET_PROD_OR_DEV === defaults.DEV
    ? AFINANDO_PLUS_LINK_DEV
    : AFINANDO_PLUS_LINK_PROD;

const PROBRAIN_ALL_PAYMENTS_PLANS_LINK_DEV =
  "https://probraindev.afinandoocerebro.com.br/planos";
const PROBRAIN_ALL_PAYMENTS_PLANS_LINK_PROD =
  "https://probrain.afinandoocerebro.com.br/planos";
export const PROBRAIN_ALL_PAYMENTS_PLANS =
  GET_PROD_OR_DEV === defaults.DEV
    ? PROBRAIN_ALL_PAYMENTS_PLANS_LINK_DEV
    : PROBRAIN_ALL_PAYMENTS_PLANS_LINK_PROD;

const API_VINDI_DEV =
  "https://sandbox-app.vindi.com.br/api/v1/public/payment_profiles";

const API_VINDI_PROD =
  "https://app.vindi.com.br/api/v1/public/payment_profiles";
export const API_VINDI =
  GET_PROD_OR_DEV === defaults.DEV ? API_VINDI_DEV : API_VINDI_PROD;

export const TOKEN_VINDI =
  GET_PROD_OR_DEV === defaults.DEV
    ? "cVdFdHhMUHl1MlpnY2ItTG1WSnRjT1p5QUNkRGZPSlM0Yml1UGV6X3FrVQ=="
    : "RExVV2hUQWRYTDNWTE4xQUtwMFpwV1hDeG1tbl8wSk1RLWoyTkhDX1FGYw==";
// ===============================
// ======= APIs ENVIROMENT =======
// ===============================

export const API_GAME_SIGN_COOKIE = API_GAME + "/activity";

// Static API URL to use
const STATIC_API_URL =
  GET_PROD_OR_DEV === defaults.DEV ? STATIC_API_DEV : STATIC_API_PROD;

//Invite Code URL to use
export const STATIC_INVITE_CODE_URL = STATIC_API_URL + "/login";

// ===============================
// ========= Statics URLS ========
// ===============================

export const STATIC_FILE_USE_TERMS =
  "https://termos.probrain.com.br/pub/terms/terms_2024.pdf";
export const STATIC_FILE_SECURITY_POLICY =
  "https://www.audbility.com.br/_files/ugd/cd0d44_f01a8753e2e647429e39e9bdb3ada60b.pdf";
export const STATIC_FILE_PRIV_POLITICS =
  "https://termos.probrain.com.br/pub/policies/policies_2024.pdf";

export const API_URL_STATIC_OPTIONS = `${API_URL}/content/options`;
export const API_URL_STATIC_NOTIFY = `${API_URL}/content/notify`;

// ===============================
// ========== APIs URLS ==========
// ===============================

// -------- GAMES API URL --------
export const GET_API_GAME_URL = (activity) => {
  const gameCache = JSON.parse(localStorage.getItem("gameCache") ?? "{}");
  const cache = activity.id in gameCache ? gameCache[activity.id] : "";
  const language_dict = {
    Português: "pt_br",
    Inglês: "en_us",
    Espanhol: "es_es",
    "Português Europeu": "pt-eu",
  };
  const {
    path,
    id,
    language,
    name = "",
    level = 0,
    engine = "default",
    version = 0,
  } = activity;
  return (
    API_GAME +
    "/" +
    path +
    `/${
      engine === "contruct_2" || true ? "index.html" : ""
    }?next=1&id_jogo=${id}&nivel=${level}&language=${language_dict[language]}&name=${encodeURIComponent(
      name,
    )}&version=${version + "-" + cache}`
  );
};

export const GET_API_AUDIO_URL = (activity) => {
  const gameCache = JSON.parse(localStorage.getItem("gameCache") ?? "{}");
  const cache = activity.id in gameCache ? gameCache[activity.id] : "";
  const { path, version = 0 } = activity;
  return API_GAME + "/" + path + "/audio.mp3";
};

export const GET_ACTIVITIES = (sub) =>
  sub
    ? `${API_URL}/content/gamesaudios-v4/${sub}`
    : `${API_URL}/content/gamesaudios-v4`;

// -------- ACCOUNT API URL --------
export const API_CHANGE_MAIL = `${API_URL}/user/email/change`;
export const API_CHECK_MAIL = (email) => {
  return `${API_URL}/user/email/check/${email}`;
};

// -------- CONTENTS API URL --------
export const API_Q_CONTENTS = `${API_URL}/content/textvideo`;

// -------- ACTIVITIES API NO AUTH --------
export const API_Q_ACTIVTS = `${API_URL}/content/gamesaudios`;
export const API_Q_ACTIVTS_V2 = `${API_URL}/content/gamesaudios-v2`;
export const API_Q_ACTIVTS_V3 = `${API_URL}/content/gamesaudios-v3`;
export const API_Q_ACTIVTS_V4 = `${API_URL}/content/gamesaudios-v3`;
//export const API_Q_ACTIVTS_V4 = `${API_GAME}/resources/${(isDev)?'games_audios_dev_v6':'games_audios_prod_v6'}.json`;

// -------------- EXTERNAL CALLS --------------
export const API_PDF_CALL = (id, sub) =>
  `${API_URL}/sales/nfeio/pdf/${id}?sub=${sub}`;

// -------- USER API URL - USERS --------
export const API_Q_USER = `${API_URL}/user`;
export const API_Q_USERS = `${API_URL}/users`;
export const API_FREE_CAN_PLAY = `${API_URL}/user/can-play`;
export const API_POST_CHANGE_FREEZE_STATUS = `${API_URL}/patient/freeze`;
export const API_POST_ADD_COIN = `${API_URL}/rewards/claim`;
export const API_POST_AUTH_TRANSPARENT = `${API_URL}/user/transparent-auth`;

// -------- USER API URL - CODE --------
export const API_Q_CODE = `${API_URL}/code`;
export const G_API_Q_CODE = ($id) => `${API_URL}/code/${$id}`;

// -------- BANNERS --------
export const G_API_GET_BANNERS = (displayedScreen) => `${API_URL}/images/${displayedScreen}`;

// -------- USER API URL - TASKS --------
export const API_Q_TASK = `${API_URL}/task`;
export const API_Q_TASK_USERS = `${API_URL}/task/users`;
export const API_Q_TASKS = `${API_URL}/tasks`;
export const GET_API_Q_USERS_HAS_TASK = (activity_id) =>
  `${API_URL}/tasks/check-users/${activity_id}`;

// -------- USER API URL - STATISTICS --------
export const API_Q_BESTPLAYS = `${API_URL}/statistics/bestplays`;
// export const API_Q_USER_BESTPLAYS = (SUB = 0) => SUB ? `${API_URL}/user/bestplays/${SUB}` : `${API_URL}/user/bestplays`;
export const API_Q_USER_BESTPLAYS = (
  user_sub,
  game_id = "",
  game_level = "",
) => {
  let bestRequest = `${API_URL}/user_sub/${user_sub}`;
  if (game_id != "") {
    bestRequest = `${bestRequest}/game_id/${game_id}`;
  }

  if (game_level != "") {
    bestRequest = `${bestRequest}/game_level/${game_level}`;
  }

  return `${bestRequest}/statistics/best-plays`;
};
export const API_Q_GET_SLIDER = (LIMIT = 0, OFFSET = 0) =>
  `${API_URL}/statistics/plays/slider/true/${LIMIT}/${OFFSET}`;
// export const API_Q_GET_SLIDERCHILD_USER = (LIMIT = 0, OFFSET = 0, USER_SUB) => `${API_URL}/statistics/plays/slider/true/${LIMIT}/${OFFSET}/sub/${USER_SUB}`;

export const API_Q_GET_SLIDERCHILD_USER = (userSub, type = "game_level") =>
  `${API_URL}/get-statistics?user_sub=${userSub}&type=${type}`;

export const API_Q_BESTPLAYSBYTASK = `${API_URL}/statistics/bestplaybytask`;
export const API_Q_PLAYS = `${API_URL}/statistics/plays`;
export const API_Q_PLAYS_CHILD_USER = (USER_SUB, GAME_ID) =>
  `${API_URL}/statistics/plays/${USER_SUB}/game/${GAME_ID}`;
export const API_Q_PLAYS_CHILD_USER_BY_DATE = (
  USER_SUB,
  GAME_ID,
  DATE_START,
  DATE_END,
) =>
  `${API_URL}/statistics/plays/${USER_SUB}/game/${GAME_ID}/date/${DATE_START}/${DATE_END}`;
export const API_GET_STATISTICS_BY_KEY = (userSub, key) =>
  `${API_URL}/get-statistics?user_sub=${userSub}&statistic=${key}`;

export const API_GET_SCORES_BY_DAY = (monthYear) =>
  `${API_URL}/statistics/get-scores-by-day/${monthYear}`;
export const API_GET_SCORES_BY_DAY_USER = (userSub, monthYear) =>
  `${API_URL}/statistics/user_sub/${userSub}/get-scores-by-day/${monthYear}`;

export const API_GET_NEXT_PAGE_PLAY_BY_GAME_LEVEL = (
  USER_SUB,
  LIMIT,
  GAME_ID,
  LEVEL,
  DATE_START,
  DATE_END,
) => {
  return `${API_URL}/get-next-statistics?user_sub=${USER_SUB}&limit=${LIMIT}&game_id=${GAME_ID}&level=${LEVEL}&date_start=${DATE_START}&date_end=${DATE_END}`;
};
/**
 * Gera URL para buscar jogadas com suporte a paginação DynamoDB via cursor
 * @param {string} querySub - ID do usuário
 * @param {string|number} limit - Limite de resultados
 * @param {string|number} offset - Offset (para compatibilidade)
 * @param {string} dateStart - Data inicial (YYYY-MM-DD)
 * @param {string} dateEnd - Data final (YYYY-MM-DD)
 * @param {Object|null} cursor - Cursor de paginação DynamoDB { pattern_sub, date_updated }
 * @returns {string} URL formatada
 */
export const API_Q_PLAYS_DEFAULT = (
  querySub = "0",
  limit = "0",
  offset = "0",
  dateStart,
  dateEnd,
  cursor = null,
) => {
  const baseUrl = `${API_URL}/statistics/plays/sub/${querySub}/limit/${limit}/offset/${offset}/date/${dateStart}/${dateEnd}`;

  const hasCursor = cursor?.pattern_sub && cursor?.date_created;

  if (!hasCursor) {
    return baseUrl;
  }

  const params = new URLSearchParams({
    pattern_sub: cursor.pattern_sub,
    date_created: cursor.date_created,
  });

  return `${baseUrl}?${params.toString()}`;
};

// -------------- PRODUCTS --------------
export const API_URL_PRODUCTS = `${API_URL}/products`;

// -------- USER API URL - SCORE --------
export const API_Q_SCORE = `${API_URL}/score`;

// -------- USER API URL - PAYMENTCARD --------

export const API_NEW_CARD = `${API_URL}/sales/card/update-to-maxipago`;
export const API_RENEW_CARD = `${API_URL}/sales/card/renew-plan`;
export const API_URL_GET_ORDER = (id) => `${API_URL}/sales/order/${id}`;
export const API_URL_SALES_ORDER = `${API_URL}/sales/process-bill`;
export const API_URL_SALES_CARDS = `${API_URL}/sales/cards`;
export const API_URL_SALES_CARD = `${API_URL}/sales/card`;
export const API_URL_SALES_UPDATE = `${API_URL}/sales/update`;
export const API_URL_SALES_UPDATES = `${API_URL}/sales/products-by-transaction`;

// fetch(API_URL_SALES_UPDATES, {
//   method: "GET",
//   headers: {
//     Authorization: Auth.user?.signInUserSession.idToken.jwtToken,
//   }
// })
//   .then(response => response.json())
//   .then(data => {
//     console.log("Dados da API:", data);
//   })
//   .catch(error => {
//     console.error("Erro ao buscar dados:", error);
//   });

// Auth.currentAuthenticatedUser()
//   .then(user => {
//     const token = user.signInUserSession.idToken.jwtToken;
//     fetch(API_URL_SALES_UPDATES, {
//       method: "GET",
//       headers: {
//         Authorization: token,
//       }
//     })
//       .then(response => response.json())
//       .then(data => {
//         console.log("Dados da API:", data);
//       })
//       .catch(error => {
//         console.error("Erro ao buscar dados:", error);
//       });
//   })
//   .catch(error => {
//     // Usuário não autenticado!
//     console.error("Usuário não autenticado:", error);
//   });
export const API_URL_SALES_USER = `${API_URL}/sales/user`;

// ---------- AUTOMATION UPDATE -----------
export const API_SEND_AUTOMATION = `${API_URL}/send-automation-tag`;

// -------- USER API URL - PARENT --------
export const API_Q_PARENT = `${API_URL}/parent`;
export const API_Q_PARENT_PLANS = `${API_URL}/parent/plans`;
export const API_Q_PARENT_THROW = `${API_URL}/user/remove-parents`;

// -------------- PLANS --------------
export const API_URL_PLANS = `${API_URL}/plans`;
export const API_URL_IS_PAID = `${API_URL}/plans/ispaid`;
export const API_URL_PLAN_CHANGE = `${API_URL}/plan/change`;
// export const GET_API_URL_PLAN_BY_ID = (planId) => `${API_URL}/plans" + planId;

// -------- USER API URL - GOALS --------
export const API_Q_GOALS = `${API_URL}/user/gamification`;
export const API_GOALS_AND_STARS = (sub) =>
  `${API_URL}/rewards/user/stars?user_sub=${sub}`;

// -------- USER API URL - MEDALS --------
export const API_Q_MEDALS = `${API_URL}/user/gamification/medals`;
export const API_Q_CREATE_MEDALS = `${API_URL}/user/gamification/medals/create`;
export const API_Q_MEDALS_IMAGE = API_GAME + "/resources/medals";
export const API_Q_MEDALS_LIST_DEV =
  API_GAME_DEV + "/resources/json_medalhas_nextdev.json";
export const API_Q_MEDALS_LIST_PROD =
  API_GAME_PROD + "/resources/json_medalhas_nextprod.json";
export const API_Q_MEDALS_LIST =
  GET_PROD_OR_DEV === defaults.DEV
    ? API_Q_MEDALS_LIST_DEV
    : API_Q_MEDALS_LIST_PROD;

// -------- USER API URL - FAVORITED --------
export const API_Q_UPDATE_FAVORITE = (id_jogo) =>
  `${API_URL}/activity/favorite/${id_jogo}`;

// -------- USER API URL - LIKE --------
export const API_Q_UPDATE_LIKE = (id_jogo) =>
  `${API_URL}/activity/like/${id_jogo}`;

// -------- USER API URL - CHILD USER --------
export const API_GET_Q_REMOVE_CHILD_USER = (sub) =>
  API_URL + `/patient/remove/${sub}`;

// -------- USER API URL - PARENT --------
export const API_Q_GYMPASS_DECRYPT = `${API_URL}/gympass/decrypt`;

// -------- STATIC --------
export const STATIC_SOCIAL_INSTAGRAM =
  "https://www.instagram.com/afinandoocerebro/";
export const STATIC_SOCIAL_YOUTUBE =
  "https://www.youtube.com/channel/UCJ7wZtwP9IOV5nM2ap1D9_w";
export const STATIC_SOCIAL_FACEBOOK =
  "https://www.facebook.com/afinandoocerebro/";

//--------------- VERSIONAMENT ----------------------------

export const API_URL_CACHE_VERSION = "/version.json";

//------------------ BOT PIXIE ---------------

const PIXIE_URL_PROD =
  "https://79oun17gq2.execute-api.us-east-1.amazonaws.com/Prod/query";
const PIXIE_URL_DEV =
  "https://79oun17gq2.execute-api.us-east-1.amazonaws.com/Dev/query";

export const PIXIE_URL =
  GET_PROD_OR_DEV === defaults.DEV ? `${API_URL}/chatbot` : `${API_URL}/chatbot`;

// -----------------------------------------------
// ------------------ IS OLD? --------------------
// -----------------------------------------------

export const R_TOUR =
  GET_PROD_OR_DEV === defaults.DEV
    ? "https://afinandotourfile.s3.amazonaws.com/tour/tour.pdf"
    : "https://afinandotourfile.s3.amazonaws.com/tour/tour.pdf";

// export let userType = "";
// userType = "user_single";
// userType = "user_pro";

// export const API_URL_USER = "/v1/users/user/";

// export const API_GET_Q_USER_LOGIN = (user_id = null) => API_URL_USER + user_id;

// export const API_Q_MY_USER_USERS = "/v1/users/user/patients";
// export const API_Q_STATIST_USER_USERS = "/v1/statistics/user/patients";
// export const API_GET_Q_STATIST_USER_PROGRESS = (sub = "ERROR_ID") =>
//   `/v1/statistics/user/progress/${sub}`;
// export const API_GET_Q_STATIST_GENERAL_PROGRESS = (sub = "ERROR_ID") =>
//   `/v1/statistics/user/general_progress/${sub}`;
// export const API_Q_PLANS = "/v1/plans";
// export const API_GET_Q_USER_TASKS = (sub = "ERROR_ID") =>
//   `/v1/tasks/${sub}/task`;

// const API_URL_DEV = "http://nextdev.afinandoocerebro.com.br";
// "fhttps://thingproxy.freeboard.io/fetch/" +

//ENDPOINT SHOP
export const AFINANDO_STORE =
  GET_PROD_OR_DEV === "dev"
    ? "https://afinando-store-dev.s3.amazonaws.com"
    : "https://afinando-store-prod.s3.amazonaws.com";
export const API_SHOP_DOWNLOAD = (id, sub) =>
  API_URL + `/rewards/download?reward_id=${id}&user_sub=${sub}`;
export const API_SHOP_PRODUCTS = (sub) => API_URL + `/rewards?user_sub=${sub}`;
export const API_SHOP_CATEGORY = (sub, category) =>
  API_URL + `/rewards?user_sub=${sub}&category=${category}`;
export const API_UPDATE_AVATAR = `${API_URL}/user/avatar`;
export const API_EVENT_CONFIG = `${API_URL}/ticket-config`;
export const API_TICKET_REWARD = (sub, layout, ticket_id) =>
  `${API_URL}/ticket-reward?user_sub=${sub}&layout=${layout}&ticket_id=${ticket_id}`;
export const API_TICKET_USER = (sub) =>
  `${API_URL}/ticket-user?user_sub=${sub}`;
export const API_SHOP_BUY = `${API_URL}/rewards`;
export const BUCKET_SHOP_IMAGES = (slug) =>
  AFINANDO_STORE + "/" + slug + "/thumbnail.png";

export const PIXIE_BOT_API_KEY = "ayE8xei1Ie3nobVahUuRN8e885pjqhdwasw1je6d";

export const URL_V4_WEBHOOKS =
  "https://n8n-n8n.hf766q.easypanel.host/webhook/probrain";

//Endpoint para gerar PDF do progresso
export const createPDF = `${API_URL}/create-pdf-scores`;

// Personalized training quiz responses
export const API_SEND_RESPONSES_QUIZ = `${API_URL}/send-responses-quiz`;

// -------- GET STATISTICS (quantitativo de jogadas) --------
// Retorna contagem de jogos por jogo, por habilidade e geral
// statistic pode ser:
//   - vazio: retorna todas as estatísticas
//   - "total_games_played": retorna só o total de jogos jogados
//   - nome da habilidade (ex: "memoria"): retorna estatísticas da habilidade
//   - game:level (ex: "110:1"): retorna estatísticas do jogo/nível específico
const API_GET_STATISTICS_BASE =
  "https://sandbox.afinando.com.br/get-statistics";
export const API_GET_STATISTICS = (userSub, statistic = null) => {
  let url = `${API_GET_STATISTICS_BASE}?user_sub=${userSub}`;
  if (statistic) {
    url += `&statistic=${encodeURIComponent(statistic)}`;
  }
  return url;
};

const API_GET_DAYS_PLAYED_BASE = `${API_URL}/get-days-played`;
export const API_GET_DAYS_PLAYED = (userSub) => {
  let url = `${API_GET_DAYS_PLAYED_BASE}?user_sub=${userSub}`;
  return url;
};

export const API_GET_RANKING_EVENTS = (eventType, expiration_date = null) => {
  let url = `${API_URL}/event?type=${eventType}`;
  if (expiration_date) {
    url += `&expiration_date=${encodeURIComponent(expiration_date)}`;
  }
  return url;
};
export const API_RANKING_PARTICIPATION = `${API_URL}/event/confirm`;

export const API_GET_RANKING_FROM_XP_DB = (
  game_id = null,
  expiration_date,
  user_sub,
) => {
  if (game_id) {
    return `${API_URL}/ranking?game_id=${game_id}&expiration_date=${encodeURIComponent(expiration_date)}&user_sub=${user_sub}`;
  }else if(expiration_date){
    return `${API_URL}/ranking?expiration_date=${encodeURIComponent(expiration_date)}&user_sub=${user_sub}`;
  }
};

export const API_GET_ALL_RANKING_FROM_XP_DB = (user_sub) => {
  return `${API_URL}/ranking/games?user_sub=${user_sub}`;
}

export const API_GET_LAST_RANKING_FROM_XP_DB = (expiration_date, user_sub) => {
  return `${API_URL}/ranking/games?expiration_date=${encodeURIComponent(expiration_date)}&user_sub=${user_sub}`;
}
export const API_FINALIZE_RANKING = `${API_URL}/event/confirm/done`;

export const API_CONFIRM_RANKING_PARTICIPATION = `${API_URL}/event/confirm`;
